module.exports = __webpack_public_path__ + "labioplastika_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_2_after.jpg
// module id = 1069
// module chunks = 0